<template>
  <div>
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            基础信息
          </div>
        </template>
        <div class="collapse-content">
          <SiruiSearch
            ref="baseInfoFormRef"
            :query="baseFormData"
            :columns="formColumn"
            :isQueryPanel="false"
            :rules="baseFormRules"
            labelWidth="130px"
            @changeMethod="changeMethod"
          ></SiruiSearch>
        </div>
      </el-collapse-item>

      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            附件上传
          </div>
        </template>
        <div class="collapse-content">
          <FileTable ref="fileTableRef" :attachments="attachments" :isShowDownBtn="isDetail" />
        </div>
      </el-collapse-item>
    </el-collapse>
    <!-- 按钮组 -->
    <div class="btn-group">
      <el-button
        type="primary"
        key="777"
        @click="_saveHandler(false)"
        :disabled="isDetail"
        :loading="load"
      >
        保存
      </el-button>
      <el-button
        type="primary"
        key="111"
        @click="_saveHandler(true)"
        :disabled="!['', '01', '04'].includes(baseFormData.auditStatus) || isDetail"
        :loading="load"
      >
        提交
      </el-button>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { dateFormatter } from '@/common/js/util';
  export default {
    name: 'temporaryLimit',
    props: [],
    data() {
      return {
        activeNames: ['1', '2'],
        baseFormData: {
          creditRequestNo: '', //临时额度申请单编号
          projectCompanyName: '', //公司
          projectCompanyCode: '',
          projectCode: '', //项目编号
          projectName: '', //项目名称
          applyDate: '', //申请日期
          longProjectQuota: '0', //立项使用额度
          longProjectReceivableQuota: '0', //立项应收账款额度
          quotaType: '', //账款类型
          creditType: 'SX02', //授信类型
          lackQuota: '', //本次欠缺额度
          requestAmount: '', //本次申请额度
          quotaExceedingRatio: '', //申请额度超出比例
          validDate: '', //授信有效期始
          invalidDate: '', //授信有效期止
          auditStatus: '',
          mark: '', //备注
        },
        attachments: [], //附件
        load: false,
        baseFormRules: {
          quotaType: [{ required: true, message: '请选择账款类型', trigger: ['blur', 'change'] }],
          projectName: [{ required: true, message: '请选择项目', trigger: ['blur', 'change'] }],
          projectCode: [{ required: true, message: '请选择项目', trigger: ['blur', 'change'] }],
          projectCompanyName: [{ required: true, message: '必填', trigger: ['blur', 'change'] }],
          longProjectQuota: [{ required: true, message: '必填', trigger: ['blur', 'change'] }],
          longProjectReceivableQuota: [
            { required: true, message: '必填', trigger: ['blur', 'change'] },
          ],
          applyDate: [{ required: true, message: '申请日期', trigger: ['blur', 'change'] }],
          validDate: [
            { required: true, message: '请选择授信有效期始', trigger: ['blur', 'change'] },
          ],
          invalidDate: [
            { required: true, message: '请选择授信有效期止', trigger: ['blur', 'change'] },
          ],

          creditType: [{ required: true, message: '请选择授信类型', trigger: ['blur', 'change'] }],
          // lackQuota: [{ required: true, message: '请填写本次欠缺额度', trigger: ['blur', 'change'] }],
          requestAmount: [
            { required: true, message: '请填写本次申请额度', trigger: ['blur', 'change'] },
          ],
          quotaExceedingRatio: [{ required: true, message: '必填', trigger: ['blur', 'change'] }],
          createPersonName: [
            { required: true, message: '请输入新增人', trigger: ['blur', 'change'] },
          ],
        },
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      isWuMaoAccount() {
        return ['物贸', '国贸'].includes(this.userInfo.userInfo.businessGroup);
      },
      isDetail() {
        return this.$route.query.isDetail == 'true' || this.$route.query.isDetail == true
          ? true
          : false;
      },
      formColumn() {
        let arr = [
          {
            prop: 'creditRequestNo',
            name: '临时额度申请单编号',
            type: 'input',
            placeholder: '无',
            disabled: true,
          },
          {
            prop: 'projectCompanyName',
            name: '公司',
            type: 'input',
            placeholder: '无',
            disabled: true,
          },
        ];
        if (this.isWuMaoAccount) {
          arr.push({
            prop: 'projectCode',
            name: '项目编号',
            type: 'searchTableSpec',
            searchType: 'projectListWumao',
            extraData: {
              projectInitiationStatusList: ['PIS04', 'PIS05', 'PIS07', 'PIS08'],
              applyCompanyNo: this.userInfo.userInfo.companyCode,
              applyCompanyName: this.userInfo.userInfo.companyName,
              platformtCompany: this.userInfo.userInfo.companyCode,
              platformtCompanyName: this.userInfo.userInfo.companyName,
            },
            isMultiple: true,
            changeMethod: 'changeMethod',
            currentValue: this.baseFormData?.projectCode,
            placeholder: '无',
            disabled: this.isDetail,
          });
        } else {
          arr.push({
            prop: 'projectCode',
            name: '项目编号',
            type: 'searchTableSpec',
            searchType: 'projectList1',
            extraData: {
              projectInitiationStatusList: ['PIS04', 'PIS05', 'PIS07', 'PIS08'],
              applyDepartmentNo: this.userInfo.userInfo.departmentCode,
              applyDepartmentName: this.userInfo.userInfo.departmentName,
            },
            isMultiple: true,
            changeMethod: 'changeMethod',
            currentValue: this.baseFormData?.projectCode,
            placeholder: '无',
            disabled: this.isDetail,
          });
        }
        arr.push(
          {
            prop: 'projectName',
            name: '项目名称',
            type: 'input',
            placeholder: '无',
            disabled: true,
          },
          {
            prop: 'applyDate',
            name: '申请日期',
            type: 'date',
            placeholder: '无',
            disabled: true,
          },
          {
            prop: 'longProjectQuota',
            name: '立项使用额度',
            type: 'inputNumber',
            placeholder: '无',
            append: '万元',
            disabled: true,
          },
          {
            prop: 'longProjectReceivableQuota',
            name: '立项应收账款额度',
            type: 'inputNumber',
            placeholder: '无',
            append: '万元',
            disabled: true,
          },
          {
            prop: 'quotaType',
            name: '账款类型',
            type: 'dict',
            dictType: 'QUOTA_TYPE',
            changeMethod: 'changeMethod',
            placeholder: '无',
            disabled: this.isDetail,
          },
          {
            prop: 'creditType',
            name: '授信类型',
            type: 'dict',
            dictType: 'credit_type',
            placeholder: '无',
            disabled: true,
          },
          {
            prop: 'lackQuota',
            name: '本次欠缺额度',
            type: 'inputNumber',
            placeholder: '无',
            append: '万元',
            disabled: this.isDetail,
          },
          {
            prop: 'requestAmount',
            name: '本次申请额度',
            type: 'inputNumber',
            changeMethod: 'changeMethod',
            placeholder: '无',
            append: '万元',
            disabled: this.isDetail,
          },
          {
            prop: 'quotaExceedingRatio',
            name: '申请额度超出比例',
            type: 'input',
            placeholder: '无',
            disabled: true,
          },
          {
            prop: 'validDate',
            name: '授信有效期始',
            type: 'startDaterangePicker',
            placeholder: '无',
            disabled: this.isDetail,
          },
          {
            prop: 'invalidDate',
            name: '授信有效期止',
            type: 'endDaterangePicker',
            placeholder: '无',
            disabled: this.isDetail,
          },
          {
            prop: 'mark',
            name: '备注',
            type: 'input',
            placeholder: '无',
            span: 24,
          }
        );
        return arr;
      },
    },
    mounted() {
      console.log(this.$route.query, this.userInfo.userInfo);
      if (this.$route.query.id) {
        this.getDetail();
      } else {
        if (this.$route.query.projectId) {
          this.baseFormData.lackQuota = (this.$route.query.deficientLimit / 10000.0).toFixed(6);
          this.getProjectDetail();
        }
        this.baseFormData.applyDate = dateFormatter(new Date());
      }
    },
    methods: {
      _saveHandler(submit = false) {
        const attachments = this.$refs.fileTableRef.getTableData();

        this.baseFormData.companyName = this.userInfo.userInfo.companyName;
        this.baseFormData.companyCode = this.userInfo.userInfo.companyCode;
        this.baseFormData.departmentCode = this.userInfo.userInfo.departmentCode;
        this.baseFormData.departmentName = this.userInfo.userInfo.departmentName;
        this.$refs.baseInfoFormRef.validate((valid) => {
          if (valid) {
            this.load = true;
            this.$axios
              .post('sales/creditLimitMaintain/saveTemporaryProject', {
                attachments: attachments,
                creditLimitMaintain: this.baseFormData,
                oaId: this.userInfo.userInfo.oaId,
                isSubmit: submit,
                businessGroup: this.userInfo.userInfo.businessGroup,
              })
              .then((res) => {
                this.load = false;
                if (0 == res.data.code) {
                  this.$message({
                    showClose: true,
                    message: submit ? '提交成功！' : '保存成功！',
                    type: 'success',
                  });
                  this.gotoList(this.$route.name);
                } else {
                  this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'error',
                  });
                }
              });
          }
        });
      },
      //跳转到列表页面
      gotoList(name) {
        let path = {
          fromPath: {
            path: `/project/${name}`,
            name: name,
            meta: {
              keepAlive: true,
              title: '',
            },
          },
          toPath: {
            path: '/project/projectMaintainList',
            name: 'projectMaintainList',
            meta: {
              keepAlive: false,
              title: '项目额度列表',
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      changeMethod(row) {
        console.log('changeMethodrow', row);

        if (row.prop == 'projectCode') {
          if (row.val != null && row.val.length != 0) {
            this.baseFormData.projectCompanyName = row.val[0].companyName;
            this.baseFormData.projectCompanyCode = row.val[0].companyCode;
            this.baseFormData.projectName = row.val[0].projectName;
            this.baseFormData.projectCode = row.val[0].projectInitiationNo;
            this.getProject(row.val[0].projectInitiationNo);
          } else {
            this.baseFormData.longProjectQuota = '0';
            this.baseFormData.longProjectReceivableQuota = '0';
          }
        } else if (row.prop == 'quotaType') {
          if (row.val == 'projectQuota') {
            if (this.baseFormData.longProjectQuota != '0') {
              if (
                this.baseFormData.requestAmount != '' &&
                this.baseFormData.requestAmount != null
              ) {
                this.baseFormData.quotaExceedingRatio = this.computedQuota(
                  this.baseFormData.requestAmount,
                  this.baseFormData.longProjectQuota
                );
              } else {
                this.baseFormData.quotaExceedingRatio = '';
              }
            } else {
              this.baseFormData.quotaExceedingRatio = '无法计算申请额度超出比例';
            }
          } else if (row.val == 'projectReceivableQuota') {
            if (this.baseFormData.longProjectReceivableQuota != '0') {
              if (
                this.baseFormData.requestAmount != '' &&
                this.baseFormData.requestAmount != null
              ) {
                this.baseFormData.quotaExceedingRatio = this.computedQuota(
                  this.baseFormData.requestAmount,
                  this.baseFormData.longProjectReceivableQuota
                );
              } else {
                this.baseFormData.quotaExceedingRatio = '';
              }
            } else {
              this.baseFormData.quotaExceedingRatio = '无法计算申请额度超出比例';
            }
          } else {
            this.baseFormData.quotaExceedingRatio = '';
          }
        } else if (row.prop == 'requestAmount') {
          console.log('requestAmount', row);
          if (row.val != '0' && row.val != '' && row.val != null) {
            if (this.baseFormData.quotaType == 'projectQuota') {
              if (this.baseFormData.longProjectQuota != '0') {
                this.baseFormData.quotaExceedingRatio = this.computedQuota(
                  this.baseFormData.requestAmount,
                  this.baseFormData.longProjectQuota
                );
              } else {
                this.baseFormData.quotaExceedingRatio = '无法计算申请额度超出比例';
              }
            } else if (this.baseFormData.quotaType == 'projectReceivableQuota') {
              if (this.baseFormData.longProjectReceivableQuota != '0') {
                this.baseFormData.quotaExceedingRatio = this.computedQuota(
                  this.baseFormData.requestAmount,
                  this.baseFormData.longProjectReceivableQuota
                );
              } else {
                this.baseFormData.quotaExceedingRatio = '无法计算申请额度超出比例';
              }
            } else {
              this.baseFormData.quotaExceedingRatio = '';
            }
          } else {
            this.baseFormData.quotaExceedingRatio = '';
          }
        }
      },
      getProject(projectCode) {
        this.$axios
          .post('/sales/creditLimitMaintain/listCreditLimitMaintainProject', {
            projectCode: projectCode,
            curDate: dateFormatter(new Date()),
            creditType: 'SX01',
          })
          .then((res) => {
            if (0 == res.data.code) {
              const projectQuota = res.data.data.filter((item) => item.quotaType == 'projectQuota');
              const receivables = res.data.data.filter(
                (item) => item.quotaType == 'projectReceivableQuota'
              );
              console.log('projectQuota', projectQuota, 'receivables', receivables);
              if (projectQuota != null && projectQuota.length > 0) {
                this.baseFormData.longProjectQuota = (
                  projectQuota[0].availableAmount / 10000.0
                ).toFixed(6);
                if (
                  this.baseFormData.quotaType != '' &&
                  this.baseFormData.quotaType != null &&
                  this.baseFormData.quotaType == 'projectQuota' &&
                  this.baseFormData.requestAmount != '' &&
                  this.baseFormData.requestAmount != '0' &&
                  this.baseFormData.requestAmount != null
                ) {
                  this.baseFormData.quotaExceedingRatio = this.computedQuota(
                    this.baseFormData.requestAmount,
                    this.baseFormData.longProjectQuota
                  );
                }
              } else {
                this.baseFormData.longProjectQuota = '0';
              }
              if (receivables != null && receivables.length > 0) {
                this.baseFormData.longProjectReceivableQuota = (
                  receivables[0].availableAmount / 10000.0
                ).toFixed(6);
                if (
                  this.baseFormData.quotaType != '' &&
                  this.baseFormData.quotaType != null &&
                  this.baseFormData.quotaType == 'projectReceivableQuota' &&
                  this.baseFormData.requestAmount != '' &&
                  this.baseFormData.requestAmount != '0' &&
                  this.baseFormData.requestAmount != null
                ) {
                  this.baseFormData.quotaExceedingRatio = this.computedQuota(
                    this.baseFormData.requestAmount,
                    this.baseFormData.longProjectReceivableQuota
                  );
                }
              } else {
                this.baseFormData.longProjectReceivableQuota = '0';
              }
            } else {
              //如果有错误返回，提示信息
              this.$alert(res.data.msg);
            }
          });
      },
      computedQuota(num1, num2) {
        console.log('num1', num1, 'num2', num2, (((num1 - 0) / (num2 - 0)) * 100).toFixed(2) + '%');
        if (num2 == '0' || num2 == 0 || num2 == '') {
          return '无法计算申请额度超出比例';
        }
        return (((num1 - 0) / (num2 - 0)).toFixed(4) * 100).toFixed(2) + '%';
      },
      getDetail() {
        this.$axios
          .post(`/sales/creditLimitMaintain/getTemporaryProject/${this.$route.query.id}`)
          .then((res) => {
            if (0 == res.data.code) {
              this.baseFormData = res.data.data.creditLimitMaintain;
              this.baseFormData.longProjectQuota = this.baseFormData.longProjectQuota?.toString();
              this.baseFormData.longProjectReceivableQuota =
                this.baseFormData.longProjectReceivableQuota?.toString();
              this.baseFormData.requestAmount = this.baseFormData.requestAmount?.toString();
              this.baseFormData.lackQuota = this.baseFormData.lackQuota?.toString();
              this.attachments = res.data.data.attachments;
            } else {
              this.load = false;
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          });
      },
      getProjectDetail() {
        this.$axios
          .post('sales/common/project/page', {
            projectNoLike: this.$route.query.projectId,
            businessCategory: this.isWuMaoAccount ? '02' : '01',
          })
          .then((res) => {
            if (0 == res.data.code) {
              console.log('res.data', res.data);
              if (res.data.data.records != null && res.data.data.records.length > 0)
                this.baseFormData.projectCompanyName = res.data.data.records[0].projectCompanyName;
              this.baseFormData.projectCompanyCode = res.data.data.records[0].projectCompanyNo;
              this.baseFormData.projectName = res.data.data.records[0].projectName;
              this.baseFormData.projectCode = res.data.data.records[0].projectNo;
              this.getProject(this.baseFormData.projectCode);
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          });
      },
    },
    components: {},
    watch: {},
  };
</script>

<style lang="scss" scoped></style>
